"use client";

import {tableService} from "@/service/table.service";
import {CircularProgress} from "@nextui-org/react";
import {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import NoDataFound from "./commonTemplate/noDataFound";
import SideBarLoader from "./commonTemplate/sideBarLoader";

type NeoSideBarCardProps = {
  sideBar: sideBar;
  request: any;
  setSidebarReqData: any;
};
type sideBar = {
  type: string;
  api_url: string;
  menu?: string;
};

export const SpeedDeviation: React.FC<NeoSideBarCardProps> = ({
  sideBar: sidebar,
  request: request,
  setSidebarReqData: setSidebarReqData
}) => {
  const [sideBarData, setSidebarData] = useState<any>([]);
  const [currentTrackerId, setCurrentTrackerId] = useState<any>(0);
  const [metaDate, setMetaDate] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [isSidebarLoading, setSidebarIsLoading] = useState(false);

  useEffect(() => {
    if (sidebar && sidebar.api_url && request) {
      fetchData();
    }
  }, [sidebar, request]);
  const fetchData = async () => {
    setSidebarIsLoading(true);
    const results = await tableService.onGet(sidebar.api_url, 4, request);
    setMetaDate(results.meta);
    if (results.rows.length > 0) {
      if (results.meta && results.meta.currentPage === 1) {
        setSidebarData(results.rows);
      } else {
        setSidebarData((prevData: any) => [...prevData, ...results.rows]);
      }

      if (request.pageNumber === results.meta.totalPages) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    } else {
      setHasMore(true);
      setMetaDate([]);
      setSidebarData([]);
    }
    setSidebarIsLoading(false);
  };
  useEffect(() => {
    if (sideBarData && sideBarData.length > 0) {
      if (!currentTrackerId) {
        const firstTrackerId = sideBarData[0].trackerId;
        const threshold = sideBarData[0].threshold;

        request.trackerId = firstTrackerId;
        request.threshold = threshold;

        setCurrentTrackerId(firstTrackerId);
        setSidebarReqData(request);
      } else {
        // its ignored api call when load more sidebar data
        if (currentTrackerId !== request.trackerId) {
          const currentTrackerIdData = sideBarData.find(
            (data: any) => data.trackerId === currentTrackerId
          );
          if (currentTrackerIdData) {
            const threshold = currentTrackerIdData.threshold;
            request.threshold = threshold;
          }
          request.trackerId = currentTrackerId;
          setSidebarReqData(request);
        }
      }
    }
  }, [sideBarData]);
  const changeVehicle = (data: any) => {
    request.trackerId = data.trackerId;
    request.threshold = data.threshold;
    setSidebarReqData(request);
    setCurrentTrackerId(data.trackerId);
  };

  const loadMore = () => {
    const nextPage = metaDate.currentPage + 1;
    request.pageNumber = nextPage;
    fetchData();
  };
  return (
    <>
      {isSidebarLoading && request.pageNumber && request.pageNumber == 1 ? (
        <SideBarLoader />
      ) : (
        <>
          {sideBarData && sideBarData.length == 0 ? (
            <NoDataFound />
          ) : (
            <div
              id="scrollableModal"
              className="h-[calc(100vh-100px)] overflow-y-auto "
            >
              <InfiniteScroll
                dataLength={sideBarData.length}
                next={loadMore}
                hasMore={hasMore}
                loader={
                  <div className="flex items-center justify-center p-4">
                    <CircularProgress aria-label="Loading..." color="warning" />
                  </div>
                }
                endMessage={
                  <p className="text-center text-gray-500">No more items</p>
                }
                scrollableTarget="scrollableModal"
                scrollThreshold={0.8} // Load when 80% scrolled
              >
                {sideBarData.map((data: any, index: number) => {
                  return (
                    <div
                      className="w-full max-w-md rounded-lg border bg-white p-4 shadow-md "
                      key={index}
                    >
                      <div className="flex flex-col items-center justify-between border-b-2 pb-2">
                        <h3 className="text-base font-medium text-gray-700 ">
                          {data.vehicleName}
                        </h3>
                        <span className="text-xs text-gray-500 ">
                          {data.instituteName}
                        </span>
                      </div>

                      <button
                        className={`mt-2 w-full rounded-lg  py-1 text-sm font-medium transition ${
                          currentTrackerId === data.trackerId
                            ? "bg-green-700 text-white"
                            : "bg-neo-white text-neo-black hover:bg-green-700"
                        } flex items-center justify-center gap-2`}
                        onClick={() => changeVehicle(data)}
                      >
                        View Details
                        {data.count > 0 && (
                          <span
                            className={`flex h-5 w-5 items-center justify-center rounded-full text-xs font-bold text-white ${
                              data.count > 3 ? "bg-red-500" : "bg-yellow-500"
                            }`}
                          >
                            {data.count}
                          </span>
                        )}
                      </button>
                    </div>
                  );
                })}
              </InfiniteScroll>
            </div>
          )}
        </>
      )}
    </>
  );
};
